var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('GI',{staticClass:"icon_unfind",attrs:{"name":"global_404"}}),_c('div',{staticClass:"tip"},[_vm._v(" "+_vm._s(_vm.langJson('Page not found'))+" ")]),_c('div',{staticClass:"back_index",on:{"click":_vm.jump_root}},[_vm._v(" "+_vm._s(_vm.langJson('Back to home page'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }